import type { ClientContactModel } from "./generated";

export function createClientContactModel(): ClientContactModel {
    return {
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        phone: undefined,
        mobilePhone: undefined,
        title: undefined,
        comments: undefined,
        saveSuccessful: false,
        id: 0,
        clientId: 0
    };
}
